var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5L10.5 2L11.5 1L15 4.5L14 5.5Z",
    fill: "#0767FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35 12.65L3.15 13.85L4.35 10.65L10.6 4.4L11.6 5.4L6.35 12.65Z",
    fill: "#0767FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H14",
    stroke: "#0767FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.90fe1306d461a2ebe7872146762b276b.svg";
export { ForwardRef as ReactComponent };